module.exports = __webpack_public_path__ + "img/everest_2.677255d1.jpg";